import { render, staticRenderFns } from "./InformationDefault.vue?vue&type=template&id=1d396771&scoped=true&"
import script from "./InformationDefault.vue?vue&type=script&lang=js&"
export * from "./InformationDefault.vue?vue&type=script&lang=js&"
import style0 from "./InformationDefault.vue?vue&type=style&index=0&id=1d396771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d396771",
  null
  
)

export default component.exports